import { intervalToDuration, isBefore } from 'date-fns';

$(() => {
  $('.countdown__widget').each((index, element) => {
    const $element = $(element);

    const interval = setInterval(() => {
      const now = new Date();
      const eventDate = new Date($element.data('milestone-date-utc') * 1000);

      if (!isBefore(now, eventDate)) {
        $element.parent().empty();

        if ($element.attr('id') === 'countdown-registration-opening__widget') {
          // @TODO: consider reloading the page or a modal to let the user know
          // location.reload();
        }
        clearInterval(interval);
        return;
      }

      const duration = intervalToDuration({
        start: now,
        end: eventDate,
      });

      $element.html(`
        <div class="countdown__cell">
            <div class="countdown__number custom-tertiary-color custom-tertiary-text-color">${duration.years ?? 0}</div>
            <div class="countdown__label">${window.RR.i18n.years}</div>
        </div>
        <div class="countdown__cell">
            <div class="countdown__number custom-tertiary-color custom-tertiary-text-color">${duration.months ?? 0}</div>
            <div class="countdown__label">${window.RR.i18n.months}</div>
        </div>
        <div class="countdown__cell">
            <div class="countdown__number custom-tertiary-color custom-tertiary-text-color">${duration.days ?? 0}</div>
            <div class="countdown__label">${window.RR.i18n.days}</div>
        </div>
        <div class="countdown__cell">
            <div class="countdown__number custom-tertiary-color custom-tertiary-text-color">${duration.hours ?? 0}</div>
            <div class="countdown__label">${window.RR.i18n.hours}</div>
        </div>
        <div class="countdown__cell">
            <div class="countdown__number custom-tertiary-color custom-tertiary-text-color">${duration.minutes ?? 0}</div>
            <div class="countdown__label">${window.RR.i18n.mins}</div>
        </div>
        <div class="countdown__cell">
            <div class="countdown__number custom-tertiary-color custom-tertiary-text-color">${duration.seconds ?? 0}</div>
            <div class="countdown__label">${window.RR.i18n.secs}</div>
        </div>
    `);
    }, 1000);
  });
});
